// One editable cell in the Access Control matrix/users/preview tables.
// Cycles Inherit -> None -> Read -> Write -> Inherit on click. An
// inherited cell renders the *effective* value dimmed with a dashed
// border (the `title` tooltip explains where it comes from); an explicit
// (stored) cell renders solid. Locked cells (the Admin column) are
// non-interactive and always show Write.
import { Level, LevelOrInherit, levelGlyph } from "./acHelpers";

export interface AccessLevelCellProps {
    stored: LevelOrInherit;
    effective: Level;
    locked?: boolean;
    /** The key's AREA menu (`app` / `admin`) resolves to none for this subject, so whatever this
     *  cell says is inert until the area is granted (E8). Rendered struck-through and dimmed;
     *  still editable so the grant is ready the moment the area opens. */
    gated?: boolean;
    title?: string;
    onCycle: () => void;
    ariaLabel?: string;
}

const AccessLevelCell = ({ stored, effective, locked, gated, title, onCycle, ariaLabel }: AccessLevelCellProps) => {
    const inherited = stored === "inherit";
    const shown: LevelOrInherit = inherited ? effective : stored;
    const glyph = levelGlyph(shown);
    const cls = [
        "ac-cell",
        `ac-cell--${shown}`,
        inherited ? "ac-cell--inherited" : "ac-cell--explicit",
        locked ? "ac-cell--locked" : "",
        gated ? "ac-cell--gated" : "",
    ].filter(Boolean).join(" ");

    return (
        <button
            type="button"
            className={cls}
            onClick={locked ? undefined : onCycle}
            disabled={locked}
            title={title}
            aria-label={ariaLabel}
            data-gated={gated ? "true" : undefined}
        >
            {glyph}
        </button>
    );
};

export default AccessLevelCell;
